<template>
  <div class="ModuleOne">
    <!-- <div class="ModuleOne_title">发视频/种草</div> -->

    <div class="title_box">
      <img class="title_icon" src="@/assets/home/title/title_1.png" alt="" />
    </div>
    <div class="ModuleOne_list">
      <div class="list_item" v-if="activity.douyin_switch" @click="douYin()">
        <img class="icon" src="@/assets/home/dy.png" />
        <div v-if="isRed" class="title">发视频 领红包</div>
        <div v-else class="title">发抖音</div>
      </div>
      <div class="list_item" v-if="activity.xhs_switch" @click="xhs()">
        <img class="icon" src="@/assets/home/xhs.png" />
        <!-- <div class="title">发小红书</div> -->
        <div class="title">发小红书视频</div>
      </div>
      <div class="list_item" v-if="activity.kuaishou_switch" @click="ks()">
        <div>
          <img class="icon" src="@/assets/home/kuaishou.png" />
          <div v-if="isRed" class="title">发视频 领红包</div>
          <div v-else class="title">发快手</div>
        </div>
      </div>

      <div
        class="list_item"
        v-if="activity.daijia_switch"
        @click="ProxyDriving()"
      >
        <div>
          <img class="icon" src="@/assets/home/ProxyDriving.png" />
          <div class="title">呼叫代驾</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import { getDy, getDyTwo, getXhs, getSignature } from '@/api/index';

export default {
  name: '',
  data() {
    return {
      xhs_data: {}, //小红书数据
      info: {},
      signature: [],
    };
  },

  computed: {
    ...mapState({
      activity: (state) => state.activity.form,
      PageType: (state) => state.activity.PageType,
      openid: (state) => state.activity.openid,
      // is_redpacket: (state) => state.activity.form.is_redpacket,
    }),
    //
    isRed() {
      if (
        this.activity &&
        this.activity.is_redpacket === true &&
        (this.$route.query.openid || this.openid)
      ) {
        console.log('isRed11111');
        console.log(this.$route.query.openid);
        return true;
      } else {
        console.log('isRed22222');
        console.log(this.$route.query.openid);
        return false;
      }
    },
  },

  created() {},

  methods: {
    ...mapActions('activity', ['getTouchData']),
    // 发抖音
    douYin() {
      if (this.PageType === 2 || this.PageType === '2') {
        this.$emit('openCover');
        return;
      }
      this.getTouchData({id: this.activity.id, type: 1 })
      if (
        this.activity &&
        this.activity.is_redpacket === true &&
        this.$route.query.openid
      ) {
        getDyTwo({
          id: this.activity.id,
          openid: this.$route.query.openid,
        }).then((res) => {
          window.location.href = res.data.scheme;
        });
      } else {
        getDy({ id: this.activity.id }).then((res) => {
          window.location.href = res.data.scheme;
        });
      }
    },

    // 发小红书
    xhs() {
      if (this.PageType === 2 || this.PageType === '2') {
        this.$emit('openCover');
        return;
      }
      getXhs({ id: this.activity.id }).then((res) => {
        if (res.data) {
          this.xhs_data = res.data;
          this.getTouchData({id: this.activity.id, type: 3 })
          getSignature().then((res) => {
            this.signature = res.data;
            if (
              this.xhs_data.xhs_type === 1 ||
              this.xhs_data.xhs_type === 3 ||
              this.xhs_data.xhs_type === 4
            ) {
              this.info = {
                type: 'video', // 必填，笔记类型 'video' | 'normal'
                // images: this.xhs_data.xhs_media,
                title: this.xhs_data.xhs_title, // 笔记标题
                content: this.xhs_data.xhs_content, // 笔记正文
                video: this.xhs_data.xhs_media, // 视频类型必填，必须是服务器地址
                cover:
                  this.xhs_data.xhs_media +
                  '?x-oss-process=video/snapshot,w_120,t_1000,f_jpg,m_fast,ar_auto', // 视频封面图，必须是服务器地址，暂时不支持本地文件
              };
            }
            if (this.xhs_data.xhs_type === 2) {
              this.info = {
                type: 'normal', // 必填，笔记类型 'video' | 'normal'
                images: this.xhs_data.xhs_media,
                title: this.xhs_data.xhs_title, // 笔记标题
                content: this.xhs_data.xhs_content, // 笔记正文
                // video: this.xhs_data.xhs_media, // 视频类型必填，必须是服务器地址
                // cover: this.xhs_data.xhs_media, // 视频封面图，必须是服务器地址，暂时不支持本地文件
              };
            }
            xhs.share({
              shareInfo: this.info,
              verifyConfig: {
                appKey: this.signature.appKey, //必填，应用的唯一标识,
                nonce: this.signature.nonce, // 必填，服务端生成签名的随机字符串
                timestamp: this.signature.timeStamp, // 必填，服务端生成签名的时间戳
                signature: this.signature.signature, // 必填，服务端生成的签名
              },
              fail: (e) => {
                console.log(e, '失败');
                // 调用失败时执行的回调函数
              },
            });
          });
        }
      });
    },

    // 发快手
    ks() {
      if (this.PageType === 2 || this.PageType === '2') {
        this.$emit('openCover');
        return;
      }
      this.getTouchData({id: this.activity.id, type: 2 })
      var url = this.activity.kuaishou_url;
      if (this.$route.query.openid) {
        url = url + '&openid=' + this.$route.query.openid;
      }
      if(this.$route.query && this.$route.query.platform && this.$route.query.platform === 'ks') {
        this.$emit('releaseKs');
      } else {
        url = url + '&platform=ks';
        window.location.href = url;
      }
    },

    // 呼叫代驾
    ProxyDriving() {
      if (this.PageType === 2 || this.PageType === '2') {
        this.$emit('openCover');
        return;
      }
      this.$emit('CallForAChauffeur');
    },
  },
};
</script>

<style lang="scss" scoped>
.ModuleOne {
  padding: 0 4%;
  margin-top: 10px;
  .ModuleOne_title {
    color: #ffffff;
    font-size: 13px;
    text-align: left;
    margin: 6px 0 2px 0;
    font-weight: bolder;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8),
      0 0 10px rgba(255, 255, 255, 0.3);
  }

  .title_box {
    text-align: left;
    .title_icon {
      // width: 150px;
      width: 135px;
      height: auto;
      // transform: scale(0.9);
      // position: relative;
      // left: -10px;
    }
  }

  .ModuleOne_list {
    margin-top: 5px;
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
    .list_item {
      // width: 106px;
      width: 30%;
      height: 74px;
      // background-image: url("@/assets/home/btn_bg.png");
      background-image: url('../../assets/home/btn_bg.png');
      background-repeat: round;
      background-size: cover;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin-right: 5%;
      margin-bottom: 12px;
      .icon {
        width: 35px;
        height: 35px;
        border-radius: 50%;
      }
      .title {
        font-size: 14px;
        color: #000000;
        font-weight: bold;
      }
    }
    // .list_item:last-child {
    //   margin-right: 0;
    // }
    .list_item:nth-child(3n) {
      margin-right: 0;
    }
  }
}
</style>
